interface QuickStatsProps {
  todayCompleted: number;
  weekCompleted: number;
  processing: number;
  errors: number;
}

export function QuickStats({ todayCompleted, weekCompleted, processing, errors }: QuickStatsProps) {
  return (
    <div className="bg-gray-50 dark:bg-dark-recessed border border-gray-200 dark:border-dark-border rounded-lg px-4 py-2 mb-4">
      <div className="flex items-center gap-6 text-sm">
        <div className="flex items-center gap-2" data-onboarding="stat-today">
          <span className="text-gray-500 dark:text-gray-400">Today:</span>
          <span className="font-semibold text-gray-800 dark:text-gray-100">{todayCompleted} completed</span>
        </div>
        <div className="w-px h-4 bg-gray-300 dark:bg-dark-border" />
        <div className="flex items-center gap-2" data-onboarding="stat-week">
          <span className="text-gray-500 dark:text-gray-400">This Week:</span>
          <span className="font-semibold text-gray-800 dark:text-gray-100">{weekCompleted}</span>
        </div>
        <div className="w-px h-4 bg-gray-300 dark:bg-dark-border" />
        <div className="flex items-center gap-2" data-onboarding="stat-processing">
          <span className="text-gray-500 dark:text-gray-400">Processing:</span>
          <span className={`font-semibold ${processing > 0 ? 'text-purple-600 dark:text-purple-400' : 'text-gray-800 dark:text-gray-100'}`}>
            {processing}
          </span>
        </div>
        {errors > 0 && (
          <>
            <div className="w-px h-4 bg-gray-300 dark:bg-dark-border" />
            <div className="flex items-center gap-2" data-onboarding="stat-errors">
              <span className="text-gray-500 dark:text-gray-400">Errors:</span>
              <span className="font-semibold text-red-600 dark:text-red-400">{errors}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
